import { FC, PropsWithChildren } from "react";
import { Container } from "@alexpireddu/map-ui";
import styled from "@emotion/styled";

import { CampaignCreatedHeader } from "./CampaignCreatedHeader";
import { useCities, useCityParams } from "../../hooks";

const Root = styled.div({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
});

const CampaignCreatedLayout: FC<PropsWithChildren> = ({ children }) => {
  const { cityId } = useCityParams();
  const cities = useCities().data!;
  const city = cities.find((el) => el.id === cityId);
  const isPublicSubscription = city?.subscription === 2;

  return (
    <Root>
      <CampaignCreatedHeader isPublicSubscription={isPublicSubscription} />
      <Container yGutters maxWidth="lg">
        {children}
      </Container>
    </Root>
  );
};

export default CampaignCreatedLayout;
